import { Component } from '@angular/core';

@Component({
	selector: 'lvr-section-form',
	template: `<ng-content></ng-content>`,
	styles: [
		`
			:host {
				display: grid;
				column-gap: var(--column-gap);
				row-gap: var(--row-gap);
				grid-template-columns: 1fr 1fr;
				align-items: start;
				padding: var(--inner-container-padding);
			}

			@media screen and (max-width: 1024px) {
				:host {
					grid-template-columns: 1fr;
				}
			}
		`,
	],
})
export class LvrSectionForm {}
